module.exports = __webpack_public_path__ + "img/24.50877226.jpeg";